import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LegacyUrlService {
  
  constructor(private router: Router) {}

  /**
   * Handles legacy URL redirects for DOI registered URLs
   * Removes language prefixes (tr/, en/) and redirects to new structure
   * Returns the language code if found, otherwise null
   */
  handleLegacyUrl(url: string): string | null {
    // Split URL into path and query string
    const urlParts = url.split('?');
    const path = urlParts[0];
    const queryString = urlParts.length > 1 ? urlParts[1] : '';
    
    // Remove leading slash if present
    const cleanUrl = path.startsWith('/') ? path.substring(1) : path;
    
    // Check if URL starts with language prefix
    const languagePrefixMatch = cleanUrl.match(/^(tr|en|de|ar|fr)\/(.*)/);
    
    if (languagePrefixMatch) {
      const [, langCode, remainingUrl] = languagePrefixMatch;
      // Preserve query string if exists
      const newUrl = '/' + remainingUrl + (queryString ? '?' + queryString : '');
      
      console.log(`Legacy URL detected: ${url} -> redirecting to: ${newUrl} with language: ${langCode} (query: ${queryString || 'none'})`);
      
      // Perform redirect
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
      return langCode;
    }
    
    return null;
  }

  /**
   * Gets the current URL without language prefix if present
   */
  getCurrentUrlWithoutLangPrefix(): string {
    const currentUrl = this.router.url;
    const match = currentUrl.match(/^\/(tr|en|de|ar|fr)\/(.*)/);
    return match ? '/' + match[2] : currentUrl;
  }

  /**
   * Extracts language code from legacy URL without redirecting
   */
  extractLanguageFromUrl(url: string): string | null {
    const cleanUrl = url.startsWith('/') ? url.substring(1) : url;
    const languagePrefixMatch = cleanUrl.match(/^(tr|en|de|ar|fr)\/(.*)/);
    return languagePrefixMatch ? languagePrefixMatch[1] : null;
  }

  /**
   * Checks if current URL has legacy language prefix
   */
  hasLegacyLangPrefix(url?: string): boolean {
    const targetUrl = url || this.router.url;
    return /^\/(tr|en|de|ar|fr)\//.test(targetUrl);
  }

  /**
   * Removes language prefix from URL
   */
  removeLangPrefix(url: string): string {
    return url.replace(/^\/(tr|en|de|ar|fr)\//, '/');
  }
}